import { Injectable, isDevMode } from '@angular/core';
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class GlossaryService {
  private env = isDevMode() ? environment.testMode : environment.productionMode;

  constructor(
      private  readonly mFirestore:AngularFirestore
  ) { }


    fetchData(value: string) {
     return  this.mFirestore.collection(this.env.glossary).doc(value!).valueChanges()
    }

  fetchCounsellingGlossary() {
    return  this.mFirestore.collection(this.env.glossary).doc('counselling').valueChanges()
  }


}
